import { render } from "./EventDeletionModal.vue?vue&type=template&id=ea9edc66&scoped=true"
import script from "./EventDeletionModal.vue?vue&type=script&lang=js"
export * from "./EventDeletionModal.vue?vue&type=script&lang=js"

import "./EventDeletionModal.vue?vue&type=style&index=0&id=ea9edc66&lang=css&scoped=true"

import exportComponent from "/var/www/test.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea9edc66"]])

export default __exports__